// src/index.js
import React from "react";
import ReactDOM from "react-dom/client"; // Using React 18+ createRoot
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root")); // React 18 root creation
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

reportWebVitals();
